import { Box, Container } from '@mui/material';
import { useSearchParams } from 'react-router';
import ForgotPasswordForm from './ForgotPasswordForm';

export default function ForgotPasswordScreen() {
  const [searchParams] = useSearchParams();

  const email = searchParams.get('email') || '';

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Container>
        <Box display="flex" justifyContent="center">
          <Box width="100%" maxWidth={552}>
            <ForgotPasswordForm email={email} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
